module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "partialSuccess": {
      "access denied": [
        "ACCESS_DENIED"
      ]
    }
  },
  "/ticket/*": {
    "success": {
      "ticket loaded": [
        "TICKET_LOAD"
      ]
    }
  },
  "/:slug": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    },
    "partialSuccess": {
      "access denied": [
        "ACCESS_DENIED"
      ]
    }
  }
};